import { useMutation, useQuery } from '@tanstack/react-query'
import { GET_CITY, GET_COUNTRY, GET_STATE } from '../../services/URLs'
import useRequest from '../useRequest'

const QUERIES = {
  COUNTRIES: 'COUNTRIES',
}

const MUTATIONS = {
  STATES: 'STATES',
  CITIES: 'CITIES',
}

export const useGetCountries = () => {
  const request = useRequest();
  
  return useQuery({
    queryKey: [QUERIES.COUNTRIES],
    queryFn: async () => {
      return await request({
        method: 'get',
        url: GET_COUNTRY,
        config: {},
        completeResponse: false,
      })
    },
  })
}

export const useGetStates = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.STATES],
    mutationFn: async ({ countryCode }: { countryCode: string }) => {
      return await request({
        method: 'get',
        url: GET_STATE + `?countryCode=${countryCode}`,
        config: {},
        completeResponse: false,
      })
    },
  })
}

export const useGetCities = () => {
  const request = useRequest();
  
  return useMutation({
    mutationKey: [MUTATIONS.CITIES],
    mutationFn: async ({ countryCode, stateCode }: { countryCode: string; stateCode: string }) => {
      return await request({
        method: 'get',
        url: GET_CITY + `?countryCode=${countryCode}&stateCode=${stateCode}`,
        config: {},
        completeResponse: false,
      })
    },
  })
}